import React from 'react';
import Logger from '../../util/Logger';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import './ColorPicker.css';

export default class ColorPicker extends React.Component {

  constructor (props) {
    super(props);

    const { color, onChanged } = props;

    if (!color) {
      Logger.assert('Missing color in ColorPicker component');
    }

    if (!onChanged) {
      Logger.assert('Missing onChanged callback in ColorPicker component');
    }

    this.state = {
      displayColorPicker: false,
      color: color || '#FFFFFF',
      colorSwatch: this.getColorSwatch(color || '#FFFFFF')
    };
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  handleChange = (color) => {
    this.setState({
      color: color.rgb,
      colorSwatch: this.getColorSwatch(color.hex)
    })
    const { onChanged } = this.props;
    onChanged(color);
  };

  getColorSwatch = (color) => {
    return {
      width: '36px',
      height: '14px',
      border: '1px solid lightgrey',
      borderRadius: '2px',
      background: color,
    };
  };

  render () {
    const styles = reactCSS({
      'default': {
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });
    return (
      <div>
        <div style={ styles.swatch } onClick={ this.handleClick }>
          <div style={ this.state.colorSwatch } />
        </div>
        { this.state.displayColorPicker ? <div style={ styles.popover }>
          <div style={ styles.cover } onClick={ this.handleClose }/>
          <SketchPicker color={ this.state.color } onChange={ this.handleChange } />
        </div> : null }
      </div>
    );
  }
}
